// Cálculo das parcelas de empréstimos e financiamentos (0.24): Price (parcelas iguais), SAC (amortização
// constante, parcelas que diminuem) e sem juros (valor dividido igualmente).
import { parseYmd, ymd } from './date';

export type Sistema = 'Price' | 'SAC' | 'Sem juros';
export type ParcelaCalc = { n: number; venc: string; valor: number; juros: number; amort: number; saldo: number };

const r2 = (x: number) => Math.round(x * 100) / 100;

/** Mesmo dia nos meses seguintes; em meses mais curtos vai para o último dia (31/01 → 28/02). */
export function somarMeses(data: string, n: number) {
  const d = parseYmd(data);
  const dia = d.getDate();
  const alvo = new Date(d.getFullYear(), d.getMonth() + n, 1);
  const ultimo = new Date(alvo.getFullYear(), alvo.getMonth() + 1, 0).getDate();
  alvo.setDate(Math.min(dia, ultimo));
  return ymd(alvo);
}

/** Valor da parcela fixa (Price). taxa em % ao mês. */
export function parcelaPrice(valor: number, taxa: number, n: number) {
  if (n <= 0) return 0;
  const i = taxa / 100;
  return i > 0 ? valor * i / (1 - Math.pow(1 + i, -n)) : valor / n;
}

export function calcularParcelas(valor: number, taxa: number, n: number, sistema: Sistema, primeira: string): ParcelaCalc[] {
  if (!(valor > 0) || !(n > 0) || !primeira) return [];
  n = Math.min(Math.round(n), 600);
  const i = sistema === 'Sem juros' ? 0 : Math.max(0, taxa) / 100;
  const out: ParcelaCalc[] = [];
  let saldo = valor;
  const fixa = parcelaPrice(valor, i * 100, n);
  const amortSac = valor / n;
  for (let k = 1; k <= n; k++) {
    const juros = saldo * i;
    let amort = sistema === 'SAC' ? amortSac : fixa - juros;
    if (k === n) amort = saldo;   // última parcela fecha o saldo (sem sobra de centavos)
    const parcela = amort + juros;
    saldo = Math.max(0, saldo - amort);
    out.push({ n: k, venc: somarMeses(primeira, k - 1), valor: r2(parcela), juros: r2(juros), amort: r2(amort), saldo: r2(saldo) });
  }
  return out;
}

/** Primeira parcela pelo sistema (para mostrar no cadastro antes de salvar). */
export function primeiraParcela(valor: number, taxa: number, n: number, sistema: Sistema) {
  if (!(valor > 0) || !(n > 0)) return 0;
  if (sistema === 'Sem juros') return r2(valor / n);
  if (sistema === 'SAC') return r2(valor / n + valor * (taxa / 100));
  return r2(parcelaPrice(valor, taxa, n));
}
